
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import MissionForm from './Form.vue';

const { create } = api.mission;

@Component({
  components: { MissionForm },
})
export default class MissionCreate extends Vue {
  loading: boolean = false;

  async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status } = await create(form);
      this.loading = false;
      if (status === 1) {
        await this.$router.back();
      }
    }
  }
}
